import { Button, DialogProps } from '@mui/material/';
import { ReactNode } from 'react';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialogTitle, StyledIconButton } from './Modal.styles';
import { useTranslation } from 'react-i18next';

export interface IModal extends DialogProps {
  handleClose: () => void;
  header?: ReactNode;
  mainContent?: ReactNode;
  isSaveButton?: boolean;
  handleSave?: () => void;
  buttons?: ReactNode;
  contentDividers?: boolean;
  dataTestId?: string;
}

export const Modal = ({
  open,
  maxWidth = 'xs',
  fullWidth,
  handleClose,
  header,
  contentDividers,
  mainContent,
  isSaveButton,
  handleSave,
  buttons,
  dataTestId,
}: IModal) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      data-testid={dataTestId}
    >
      <StyledDialogTitle>{header}</StyledDialogTitle>
      <StyledIconButton onClick={handleClose}>
        <CloseIcon />
      </StyledIconButton>
      <DialogContent dividers={contentDividers}>{mainContent}</DialogContent>
      <DialogActions>
        {buttons ? (
          buttons
        ) : (
          <>
            <Button variant={isSaveButton ? 'outlined' : 'contained'} onClick={handleClose}>
              {t('close')}
            </Button>
            {isSaveButton && (
              <Button variant="contained" onClick={handleSave}>
                {t('save')}
              </Button>
            )}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
